/**
 * Converter Default Units
 *
 * An enumeration for Default Converter Units per Converter Flavour

 */
var Default = {


    /**
     * @property {String} LEN
     * Default unit code for flavour LEN
     */
    LEN: 'len_m',
    /**
     * @property {String} BUSHEL
     * Default unit code for flavour BUSHEL
     */
    BUSHEL: 'mass_g',
    /**
     * @property {String} PIECE
     * Default unit code for flavour PIECE
     */
    PIECE: 'piece_grain',
    /**
     * @property {String} PRESSURE
     * Default unit code for flavour PRESSURE
     */
    PRESSURE: 'pressure_bar',
    /**
     * @property {String} LIQUIDPERLEN
     * Default unit code for flavour LIQUIDPERLEN
     */
    LIQUIDPERLEN: 'liquidPERlen_lperkm',
    /**
     * @property {String} WARTUNGSMELDUNG
     * Default unit code for flavour WARTUNGSMELDUNG
     */
    WARTUNGSMELDUNG: 'wartungsmeldung_roh',
    /**
     * @property {String} LIQUIDPERAREAL
     * Default unit code for flavour LIQUIDPERAREAL
     */
    LIQUIDPERAREAL: 'liquidPERareal_lperha',
    /**
     * @property {String} ACCELERATION
     * Default unit code for flavour ACCELERATION
     */
    ACCELERATION: 'acceleration_mperqs',
    /**
     * @property {String} PIECEPERAREAL
     * Default unit code for flavour PIECEPERAREAL
     */
    PIECEPERAREAL: 'piecePERareal_grainperha',
    /**
     * @property {String} TIME
     * Default unit code for flavour TIME
     */
    TIME: 'time_s',
    /**
     * @property {String} POSITION
     * Default unit code for flavour POSITION
     */
    POSITION: 'position_grad',
    /**
     * @property {String} MASSPERAREAL
     * Default unit code for flavour MASSPERAREAL
     */
    MASSPERAREAL: 'massPERareal_kgperha',
    /**
     * @property {String} LIQUIDPERTIME
     * Default unit code for flavour LIQUIDPERTIME
     */
    LIQUIDPERTIME: 'liquidPERtime_lperh',
    /**
     * @property {String} CURRENCY
     * Default unit code for flavour CURRENCY
     */
    CURRENCY: 'currency_default',
    /**
     * @property {String} BOOLEAN
     * Default unit code for flavour BOOLEAN
     */
    BOOLEAN: 'boolean_io',
    /**
     * @property {String} MASSPERTIME
     * Default unit code for flavour MASSPERTIME
     */
    MASSPERTIME: 'massPERtime_kgperh',
    /**
     * @property {String} LIQUID
     * Default unit code for flavour LIQUID
     */
    LIQUID: 'liquid_ml',
    /**
     * @property {String} MASS
     * Default unit code for flavour MASS
     */
    MASS: 'mass_g',
    /**
     * @property {String} SPEED
     * Default unit code for flavour SPEED
     */
    SPEED: 'speed_ms',
    /**
     * @property {String} AREALPERTIME
     * Default unit code for flavour AREALPERTIME
     */
    AREALPERTIME: 'arealPERtime_qmperh',
    /**
     * @property {String} LIQUIDPERMASS
     * Default unit code for flavour LIQUIDPERMASS
     */
    LIQUIDPERMASS: 'liquidPERmass_lpert',
    /**
     * @property {String} CONCENTRATION
     * Default unit code for flavour CONCENTRATION
     */
    CONCENTRATION: 'concentration_gpml',
    /**
     * @property {String} DATATYP
     * Default unit code for flavour DATATYP
     */
    DATATYP: 'datatyp_byte',
    /**
     * @property {String} ELECTRICITY
     * Default unit code for flavour ELECTRICITY
     */
    ELECTRICITY: 'electricity_a',
    /**
     * @property {String} DEFAULT
     * Default unit code for flavour DEFAULT
     */
    DEFAULT: 'default_digit',
    /**
     * @property {String} PERCENTAGE
     * Default unit code for flavour PERCENTAGE
     */
    PERCENTAGE: 'percentage_pdmil',
    /**
     * @property {String} VOLTAGE
     * Default unit code for flavour VOLTAGE
     */
    VOLTAGE: 'voltage_v',
    /**
     * @property {String} TEMP
     * Default unit code for flavour TEMP
     */
    TEMP: 'temp_degreecelsius',
    /**
     * @property {String} AREAL
     * Default unit code for flavour AREAL
     */
    AREAL: 'areal_qm',
    /**
     * @property {String} ROUNDS
     * Default unit code for flavour ROUNDS
     */
    ROUNDS: 'rounds_umin',

    /**
     * locale specific defaults
     * @private
     */
    locales : {
        'de_DE' : {
            LEN : 'len_km',
            BUSHEL : 'mass_g',
            PIECE : 'piece_grain',
            PRESSURE : 'pressure_bar',
            LIQUIDPERLEN : 'liquidPERlen_lperkm',
            WARTUNGSMELDUNG : 'wartungsmeldung_wert',
            LIQUIDPERAREAL : 'liquidPERareal_lperha',
            ACCELERATION : 'acceleration_mperqs',
            PIECEPERAREAL : 'piecePERareal_grainperha',
            TIME : 'time_s',
            POSITION : 'position_grad',
            MASSPERAREAL : 'massPERareal_tperha',
            LIQUIDPERTIME : 'liquidPERtime_lperh',
            CURRENCY : 'currency_euro',
            BOOLEAN : 'boolean_io',
            MASSPERTIME : 'massPERtime_tperh',
            LIQUID : 'liquid_l',
            MASS : 'mass_g',
            SPEED : 'speed_ms',
            AREALPERTIME : 'arealPERtime_haperh',
            LIQUIDPERMASS : 'liquidPERmass_lpert',
            CONCENTRATION : 'concentration_gpml',
            DATATYP : 'datatyp_byte',
            ELECTRICITY : 'electricity_a',
            DEFAULT : 'default_digit',
            PERCENTAGE : 'percentage_pc',
            VOLTAGE : 'voltage_v',
            TEMP : 'temp_degreecelsius',
            AREAL : 'areal_ha',
            ROUNDS : 'rounds_umin'
        },
        'en_GB' : {
            LEN : 'len_mile',
            BUSHEL : 'mass_g',
            PIECE : 'piece_grain',
            PRESSURE : 'pressure_bar',
            LIQUIDPERLEN : 'liquidPERlen_lperkm',
            WARTUNGSMELDUNG : 'wartungsmeldung_roh',
            LIQUIDPERAREAL : 'liquidPERareal_lperha',
            ACCELERATION : 'acceleration_mperqs',
            PIECEPERAREAL : 'piecePERareal_grainperha',
            TIME : 'time_s',
            POSITION : 'position_grad',
            MASSPERAREAL : 'massPERareal_tperacre',
            LIQUIDPERTIME : 'liquidPERtime_gallonperh',
            CURRENCY : 'currency_pound',
            BOOLEAN : 'boolean_io',
            MASSPERTIME : 'massPERtime_kgperh',
            LIQUID : 'liquid_gallon',
            MASS : 'mass_g',
            SPEED : 'speed_ms',
            AREALPERTIME : 'arealPERtime_acreperh',
            LIQUIDPERMASS : 'liquidPERmass_lpert',
            CONCENTRATION : 'concentration_gpml',
            DATATYP : 'datatyp_byte',
            ELECTRICITY : 'electricity_a',
            DEFAULT : 'default_digit',
            PERCENTAGE : 'percentage_pdmil',
            VOLTAGE : 'voltage_v',
            TEMP : 'temp_degreecelsius',
            AREAL : 'areal_acre',
            ROUNDS : 'rounds_rpm'
        },
        'ru_RU' : {
            LEN : 'len_km',
            BUSHEL : 'mass_g',
            PIECE : 'piece_grain',
            PRESSURE : 'pressure_bar',
            LIQUIDPERLEN : 'liquidPERlen_lperkm',
            WARTUNGSMELDUNG : 'wartungsmeldung_wert',
            LIQUIDPERAREAL : 'liquidPERareal_lperha',
            ACCELERATION : 'acceleration_mperqs',
            PIECEPERAREAL : 'piecePERareal_grainperha',
            TIME : 'time_s',
            POSITION : 'position_grad',
            MASSPERAREAL : 'massPERareal_tperha',
            LIQUIDPERTIME : 'liquidPERtime_lperh',
            CURRENCY : 'currency_euro',
            BOOLEAN : 'boolean_io',
            MASSPERTIME : 'massPERtime_tperh',
            LIQUID : 'liquid_l',
            MASS : 'mass_g',
            SPEED : 'speed_ms',
            AREALPERTIME : 'arealPERtime_haperh',
            LIQUIDPERMASS : 'liquidPERmass_lpert',
            CONCENTRATION : 'concentration_gpml',
            DATATYP : 'datatyp_byte',
            ELECTRICITY : 'electricity_a',
            DEFAULT : 'default_digit',
            PERCENTAGE : 'percentage_pc',
            VOLTAGE : 'voltage_v',
            TEMP : 'temp_degreecelsius',
            AREAL : 'areal_ha',
            ROUNDS : 'rounds_umin'
        }
    }
};

global.Default = Default;
